var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5306 13.4693L11.5625 10.4999C12.4524 9.34021 12.8679 7.88541 12.7247 6.43063C12.5814 4.97585 11.8902 3.63002 10.7911 2.66616C9.69209 1.7023 8.26757 1.19257 6.80654 1.24039C5.34551 1.2882 3.95736 1.88998 2.9237 2.92364C1.89004 3.9573 1.28827 5.34544 1.24045 6.80648C1.19263 8.26751 1.70236 9.69203 2.66622 10.7911C3.63008 11.8901 4.97591 12.5814 6.43069 12.7246C7.88547 12.8678 9.34027 12.4524 10.5 11.5624L13.4706 14.5337C13.5404 14.6034 13.6232 14.6588 13.7143 14.6965C13.8055 14.7343 13.9032 14.7537 14.0019 14.7537C14.1005 14.7537 14.1982 14.7343 14.2894 14.6965C14.3805 14.6588 14.4633 14.6034 14.5331 14.5337C14.6029 14.4639 14.6582 14.3811 14.696 14.2899C14.7337 14.1988 14.7532 14.1011 14.7532 14.0024C14.7532 13.9038 14.7337 13.8061 14.696 13.7149C14.6582 13.6238 14.6029 13.5409 14.5331 13.4712L14.5306 13.4693ZM2.74998 6.99991C2.74998 6.15934 2.99923 5.33765 3.46623 4.63874C3.93323 3.93983 4.59698 3.3951 5.37357 3.07343C6.15016 2.75175 7.00469 2.66759 7.82911 2.83158C8.65353 2.99556 9.41081 3.40034 10.0052 3.99471C10.5996 4.58908 11.0043 5.34636 11.1683 6.17078C11.3323 6.9952 11.2481 7.84973 10.9265 8.62632C10.6048 9.40291 10.0601 10.0667 9.36115 10.5337C8.66224 11.0007 7.84055 11.2499 6.99998 11.2499C5.87316 11.2488 4.79283 10.8006 3.99605 10.0038C3.19927 9.20706 2.75113 8.12673 2.74998 6.99991Z",
    fill: "#B8B8B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.09a2c9a95ff95196a25506b22e438b36.svg";
export { ForwardRef as ReactComponent };